import FormatsTime from "./data/formats-time";

// todo - export all as consts
const Global = {
    ADMIN_PASS_HASH: 'f4ccbda72bfa7a2df4d84a69a605686576444e61f5c9cdac666beef34847', // Funiculi
    LOCAL_STORAGE_ITEM_NAME: 'flapp',
    DOCUMENT_CACHE_EXPIRATION: 1 * 60 * 1000,
    ROLLUP_CACHE_EXPIRATION: 1 * 5 * 1000,
    TABLE_SYSTEM_MAX_ID: 499,
    EMAIL_CHUNK_RECIPIENTS_NUMBER: 1000,
    DEFAULT_NOTIFICATIN_LISTENER: 'app',
    DEFAULT_PASSWORD: '123',
    DEFAULT_TABLE_ICON: 'spreadsheet',
    DEFAULT_TABLE_VIEW_ID: 0,
    DEFAULT_TABLE_VIEW_ICON: 'spreadsheet',
    DEFAULT_MODULE_ICON: 'category',
    DEFAULT_CONNECTION_MODULE_ICON: 'links',
    DEFAULT_PLANNING_ICON: 'calendar',
    DEFAULT_SCHEDULER_ICON: 'scheduler',
    DEFAULT_LANGUAGE: 'en',
    GOOGLE_API_KEY: 'AIzaSyBbJRN6OdHq7eJK-RaGtJgN-pGlcTGTVPs',
    GOOGLE_EVENT_RENDER: 'https://calendar.google.com/calendar/render',
    BITLY_ADDRESS: 'https://api-ssl.bitly.com/v3/shorten',
    BITLY_TOKEN: '0003d479c48dff84a3e97565d77c9a9414c342f2',
    EMAIL_CONTENT_TYPE: 'text/html',
    EMAIL_PERS_MAX_SIZE: 10000,
    SYS_MSG_SENDER_PRIVATE: 'FrameLink Automatic Support',
    SYS_MSG_SENDER_PUBLIC: 'FrameLink Support',
    SYS_EMAIL_ADDRESS: 'support@framelink.co',
    SYS_EMAIL_REG_SUBJ: 'New User Registered',
    SYS_EMAIL_REG_RECIPIENT: ['joaool@framelink.co'],
    SYS_EMAIL_REG_CC: ['igor@framelink.co', 'igorkislyakov@gmail.com', 'nico@framelink.co'],
    SYS_EMAIL_ERROR_RECIPIENT: ['igorkislyakov@gmail.com', 'nico@framelink.co'],
    SYS_EMAIL_ERROR_CC: ['igor@framelink.co'],
    PROD_INSTANCE_NAME: 'main',
    SUPPORT_ADDRESS: 'https://whereby.com/framelink',
    PUBLIC_USER_SUFFIX: '_public_user',
    FORMULA_PROP_PREFIX: 'd',
    FEEDBACK_PROP_NAME: 'feedback',
    MIN_NUMBER: -9e100,
    ACTION_STRING_SEPARATOR: '::::',
    ACTION_STRING_EMPTY: '-',
    DEFAULT_ROLLUP_NAME: 'NO_NAME',
    REL_SUB_MASTER: '@MasterName',
    REL_SUB_DETAIL: '@DetailName',
    EXCEL_BLOB_TYPE: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    PDF_BLOB_TYPE: 'application/pdf',
    EXCEL_FONT_NAME: 'Arial',
    EXCEL_DEFAULT_FILE_NAME: 'FrameLink',
    EXCEL_GLOBAL_NAME_TIME_FORMAT: 'DD-MM-YYYY',
    EXCEL_SHEET_OVERFLOW: '...',
    PDF_TEMPLATE_MAX_DOCS: 5,
    EXCEL_SHEET_MAX_LENGTH: 31,
    EXCEL_FONT_SIZE: 12,
    EXCEL_PIXELS_PER_UNIT: 7.5,
    EXCEL_COL_MIN_WIDTH: 2,
    EXCEL_COL_MAX_WIDTH: 50,
    EXCEL_TOTAL_COL_WIDTH: 7,
    EXCEL_COL_EXTRA_WIDTH: 11,
    EXCEL_NOSPACE_CURRENCIES: ['$', '€', '£'],
    EXCEL_SHEET_MAX_COLS: 100,
    VERIFICATION_TIMEOUT_VERIFY: 2 * 60 * 1000,
    VERIFICATION_TIMEOUT_CREATE: 24 * 60 * 60 * 1000,
    VERIFICATION_MAX_REQUEST: 5,
    DEFAULT_DURATION: 60,
    DEFAULT_TIME_FORMAT: FormatsTime[0],
    DEFAULT_TIME_FORMAT_SEC: FormatsTime[2],
    AVATAR_COMPRESS_SCALE: 150,
    IMAGE_COMPRESS_SCALE: 300,
    PDF_OPEN_DELAY: 250,
    RELATION_CURRENT_ID: '0',
    DEFAULT_DOC_IMG_NAME: 'i',
    MAX_FILENAME_LENGTH: 1000,
    MS_IN_MINUTE: 60 * 1000
};

export default Global;